import * as L from 'leaflet';
import { AlertSeverity, ThingAlertStatus } from '../../../model';
import { MapFilterRequiredData } from '../../../model/map-filter-required-data';
import { MapContext } from '../map.component';
import { LocationForMap, ThingForMap } from '../map.service';
import { MapFilter, MARKER_SVG } from './map-filter';

export class StatusMapFilter implements MapFilter {

    private icons: any[] = [];
    private config: any;
    private context: MapContext;
    private rankDescriptor = [
        { 'label': 'Normal', value: 'NORMAL', 'rank': 0, 'color': '#424242', 'clusterClass': 'cluster-normal', 'clusterSelectedClass': 'cluster-normal-selected' },
        { 'label': 'Warning', value: 'WARNING', 'rank': 1, 'color': '#FFA726', 'clusterClass': 'cluster-warning', 'clusterSelectedClass': 'cluster-warning-selected' },
        { 'label': 'Critical', value: 'CRITICAL', 'rank': 2, 'color': '#FB4E3D', 'clusterClass': 'cluster-critical', 'clusterSelectedClass': 'cluster-critical-selected' }
    ];

    constructor(config: any) {
        this.config = config || {};
        this.config.label = this.config.label || "Status";

        this.rankDescriptor.forEach((rd, i) => {
            this.icons.splice(i, 0,
                L.divIcon({
                    html: MARKER_SVG,
                    className: `marker-${rd.label.toLocaleLowerCase()}`,
                    iconSize: [26, 40],
                    iconAnchor: [13, 40],
                })
            );
            this.icons.push(
                L.divIcon({
                    html: MARKER_SVG,
                    className: `marker-${rd.label.toLocaleLowerCase()}-selected`,
                    iconSize: [26, 40],
                    iconAnchor: [13, 40],
                })
            );
        });
    }

    setContext(context: MapContext): void {
        this.context = context;
    }

    getRequiredData(): MapFilterRequiredData {
        const requireData = new MapFilterRequiredData();
        if (this.context == MapContext.THINGS) {
            requireData.things = true;
            requireData.locations = false;
            requireData.alerts = true;
        } else {
            requireData.things = false;
            requireData.locations = true;
            requireData.alerts = true;
        }
        return requireData;
    }

    getConfig(): any {
        return this.config;
    }

    computeRank(elements: ThingForMap[] | LocationForMap[], data: any): void {
        let alertMap: { [key: string]: number; };
        if (this.context == MapContext.THINGS) {
            alertMap = this.getThingAlerts(data.alerts);
        } else {
            alertMap = this.getLocationAlerts(data.alerts);
        }
        elements.forEach(el => {
            el.rank = alertMap[el.id] || 0;
        });
    }

    updateMarker(element: ThingForMap | LocationForMap, marker: any): void {
        if (element.selected) {
            marker.setIcon(this.icons[this.rankDescriptor.length + element.rank]);
        } else {
            marker.setIcon(this.icons[element.rank]);
        }
    }

    getRankDescriptors(): any[] {
        return this.rankDescriptor;
    }

    private getThingAlerts(alerts: ThingAlertStatus[]): { [thingId: string]: number } {
        const thingAlertStatusMap: { [thingId: string]: number } = {};
        alerts.forEach(a => {
            if (a.thingId) {
                const currentStatus = thingAlertStatusMap[a.thingId];
                if (!currentStatus || currentStatus == 0) {
                    thingAlertStatusMap[a.thingId] = this.getAlertRankFromSeverity(a.severity);
                } else if (currentStatus == 1) {
                    const newStatus = this.getAlertRankFromSeverity(a.severity);
                    if (newStatus == 2) {
                        thingAlertStatusMap[a.thingId] = newStatus;
                    }
                }
            }
        });
        return thingAlertStatusMap;
    }

    private getLocationAlerts(alerts: ThingAlertStatus[]): { [locationId: string]: number } {
        const locationAlertStatusMap: { [locationId: string]: number } = {};
        alerts.forEach(a => {
            const currentStatus = locationAlertStatusMap[a.locationId];
            if (!currentStatus || currentStatus == 0) {
                locationAlertStatusMap[a.locationId] = this.getAlertRankFromSeverity(a.severity);
            } else if (currentStatus == 1) {
                const newStatus = this.getAlertRankFromSeverity(a.severity);
                if (newStatus == 2) {
                    locationAlertStatusMap[a.locationId] = newStatus;
                }
            }
        });
        return locationAlertStatusMap;
    }

    private getAlertRankFromSeverity(severity: AlertSeverity): number {
        switch (severity) {
            case AlertSeverity.CRITICAL:
                return 2;
            case AlertSeverity.WARNING:
                return 1;
            default:
                return 0;
        }
    }

}